import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";
import { CompareCategoryType } from "../constants/common";

export default class StandardService {
  static createStandard(params, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.post(API_ROUTES.SUPER_ADMIN_STD.CREATE_STANDARD, params);
    } else {
      return HttpUtil.post(API_ROUTES.STANDARDS.CREATE, params);
    }
  }

  static getStandards(regulationType = "S", forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(
        API_ROUTES.SUPER_ADMIN_STD.GET_STANDARDS
          .replace(regulationType ? "<regulationType>" : "?regulationType=<regulationType>", regulationType));
    } else {
      return HttpUtil.get(API_ROUTES.STANDARDS.GETSTANDARDS.replace(regulationType ? "<regulationType>" : "?regulationType=<regulationType>", regulationType));
    }
  }

  static addTopic(params, stdId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.post(
        API_ROUTES.SUPER_ADMIN_STD.ADD_TOPIC.replace("<standardId>", stdId),
        params
      );
    } else {
      return HttpUtil.post(
        API_ROUTES.STANDARDS.ADDTOPIC.replace("<standardId>", stdId),
        params
      );
    }
  }

  static editTopic(params, stdId, topicId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.put(
        API_ROUTES.SUPER_ADMIN_STD.EDIT_TOPIC.replace("<standardId>", stdId).replace(
          "<topicId>",
          topicId
        ),
        params
      );
    } else {
      return HttpUtil.put(
        API_ROUTES.STANDARDS.EDITTOPIC.replace("<standardId>", stdId).replace(
          "<topicId>",
          topicId
        ),
        params
      );
    }
  }

  static getTopics(stdId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(
        API_ROUTES.SUPER_ADMIN_STD.GET_TOPICS.replace("<standardId>", stdId)
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.STANDARDS.GETTOPICS.replace("<standardId>", stdId)
      );
    }
  }

  static getMetrics(stdId, topicId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(
        API_ROUTES.SUPER_ADMIN_STD.GET_METRICS.replace("<standardId>", stdId).replace(
          "<topicId>",
          topicId
        )
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.STANDARDS.GETMETRICS.replace("<standardId>", stdId).replace(
          "<topicId>",
          topicId
        )
      );
    }
  }

  static getDataPoints(metricId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(
        API_ROUTES.SUPER_ADMIN_STD.GET_DATAPOINTS.replace("<metricId>", metricId)
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.STANDARDS.GETDATAPOINTS.replace("<metricId>", metricId)
      );
    }
  }

  static addMetric(params, topicId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.post(
        API_ROUTES.SUPER_ADMIN_STD.ADD_METRIC.replace("<topicId>", topicId),
        params
      );
    } else {
      return HttpUtil.post(
        API_ROUTES.STANDARDS.ADDMETRIC.replace("<topicId>", topicId),
        params
      );
    }
  }

  static getTopicDetails(stdId, topicId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(
        API_ROUTES.SUPER_ADMIN_STD.GET_TOPIC_DATA.replace("<standardId>", stdId).replace(
          "<topicId>",
          topicId
        )
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.STANDARDS.GETOPICDATA.replace("<standardId>", stdId).replace(
          "<topicId>",
          topicId
        )
      );
    }
  }

  static deleteTopic(stdId, topicId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.delete(
        API_ROUTES.SUPER_ADMIN_STD.DELETE_TOPIC.replace("<standardId>", stdId).replace(
          "<topicId>",
          topicId
        )
      );
    } else {
      return HttpUtil.delete(
        API_ROUTES.STANDARDS.DELETETOPIC.replace("<standardId>", stdId).replace(
          "<topicId>",
          topicId
        )
      );
    }
  }
  static updateStandardStatus(standardId, status = "PUBLISHED", params, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.patch(
        API_ROUTES.SUPER_ADMIN_STD.UPDATE_STATUS.replace("<standardId>", standardId).replace(
          "<status>",
          status
        ),
        params
      );
    } else {
      return HttpUtil.patch(
        API_ROUTES.STANDARDS.UPDATESTATUS.replace("<standardId>", standardId).replace(
          "<status>",
          status
        ),
        params
      );
    }
  }
  static getStandardDetails(standardId, fullyLoad = false) {
    return HttpUtil.get(API_ROUTES.STANDARDS.GETSTANDARDDETAILS
      .replace("<standardId>", standardId)
      .replace("<fullyLoad>", fullyLoad));
  }

  static updateStandard(params, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.put(API_ROUTES.SUPER_ADMIN_STD.UPDATE_STANDARD.replace("<standardId>", params.id), params);

    } else {
      return HttpUtil.put(API_ROUTES.STANDARDS.UPDATESTANDARD.replace("<standardId>", params.id), params);
    }
  }

  static getMetricDetails(metricId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(
        API_ROUTES.SUPER_ADMIN_STD.GET_METRIC_DETAILS.replace("<metricId>", metricId)
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.STANDARDS.GETMETRICDETAILS.replace("<metricId>", metricId)
      );
    }
  }
  static deleteMetric(metricId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.delete(
        API_ROUTES.SUPER_ADMIN_STD.DELETE_METRIC.replace("<metricId>", metricId)
      );
    } else {
      return HttpUtil.delete(
        API_ROUTES.STANDARDS.DELETEMETRIC.replace("<metricId>", metricId)
      );
    }
  }
  static editMetric(params, metricId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.put(
        API_ROUTES.SUPER_ADMIN_STD.UPDATE_METRIC.replace("<metricId>", metricId),
        params
      );
    } else {
      return HttpUtil.put(
        API_ROUTES.STANDARDS.UPDATEMETRIC.replace("<metricId>", metricId),
        params
      );
    }
  }

  static getCategory(standardId = 0, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(
        API_ROUTES.SUPER_ADMIN_STD.GET_CATEGORY
          .replace(standardId > 0 ? "<standardId>" : "?standardId=<standardId>", standardId > 0 ? standardId : '')
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.STANDARDS.GETCATEGORY
          .replace(standardId > 0 ? "<standardId>" : "?standardId=<standardId>", standardId > 0 ? standardId : '')
      );
    }
  }
  static addDataPoint(params, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.post(
        API_ROUTES.SUPER_ADMIN_STD.ADD_DATAPOINT,
        params
      );
    } else {
      return HttpUtil.post(
        API_ROUTES.STANDARDS.ADDDATAPOINT,
        params
      );
    }
  }

  static updateDataPoint(params, dataPointId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.put(
        API_ROUTES.SUPER_ADMIN_STD.UPDATE_DATAPOINT.replace("<dataPointId>", dataPointId),
        params
      );
    } else {
      return HttpUtil.put(
        API_ROUTES.STANDARDS.UPDATEDATAPOINT.replace("<dataPointId>", dataPointId),
        params
      );
    }
  }
  static deleteDataPoint(dataPointId, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.put(
        API_ROUTES.SUPER_ADMIN_STD.DELETE_DATAPOINT.replace("<dataPointId>", dataPointId)
      );
    } else {
      return HttpUtil.put(
        API_ROUTES.STANDARDS.DELETEDATAPOINT.replace("<dataPointId>", dataPointId)
      );
    }
  }

  static getPublishedStandards(regulationType = "S", status = 'PUBLISHED') {
    return HttpUtil.get(API_ROUTES.STANDARDS.GET_PUBLISHED_STANDARDS
      .replace(regulationType ? "<regulationType>" : "?regulationType=<regulationType>", regulationType)
      .replace(status ? "<status>" : "?status=<status>", status)
    );
  }

  static getMetricData({ stdId, period, standardTypes, language = 'en', periodStart = '', periodEnd = '' }) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_GROUPED_METRIC_DATA
        .replace("<standardId>", stdId)
        .replace("<period>", period)
        .replace("<standards>", standardTypes?.toString())
        .replace("<language>", language)
        .replace(periodStart && periodEnd ? "<periodStart>" : "&periodStart=<periodStart>", periodStart)
        .replace(periodStart && periodEnd ? "<periodEnd>" : "&periodEnd=<periodEnd>", periodEnd)
    );
  }

  static getUnitsOfMeasure() {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.CONVERSION_TABLE.replace()
    );
  }

  static getTopicsByCategoryAndStandard(category, stdId, period = null, stdCat = null) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_ALL_BY_CATEGORY_AND_STANDARD
        .replace("<standardId>", stdId)
        .replace("<category>", category)
        .replace(period ? "<period>" : "?period=<period>", period ?? '')
        .replace(stdCat ? "<stdCat>" : "&stdCat=<stdCat>", stdCat ?? '')
    );
  }

  static getMetricsByFilter(stdId, period, filter, isV2 = true) {
    const apiURL = isV2 ? API_ROUTES.STANDARDS.GET_METRICS_BY_FILTER_V2 : API_ROUTES.STANDARDS.GET_METRICS_BY_FILTER;
    return HttpUtil.get(
      apiURL
        .replace("<standardId>", stdId)
        .replace("<period>", period)
        .replace("<categoryType>", filter.categoryType)
        .replace(
          filter.topicIds?.length > 0 ? "<topicIds>" : "&topicIds=<topicIds>",
          filter.topicIds?.length > 0 ? filter.topicIds?.toString() : ''
        )
        .replace(
          filter.metricIds?.length > 0 ? "<metricIds>" : "&metricIds=<metricIds>",
          filter.metricIds?.length > 0 ? filter.metricIds?.toString() : ''
        )
        .replace(
          filter.businessUnitIds?.length > 0 ? "<businessUnitIds>" : "&businessUnitIds=<businessUnitIds>",
          filter.businessUnitIds?.length > 0 ? filter.businessUnitIds?.toString() : ''
        )
        .replace(
          filter.periodFrom && filter.periodTo ? "<periodFrom>" : "&periodFrom=<periodFrom>",
          filter.periodFrom && filter.periodTo ? filter.periodFrom : ''
        )
        .replace(
          filter.periodFrom && filter.periodTo ? "<periodTo>" : "&periodTo=<periodTo>",
          filter.periodFrom && filter.periodTo ? filter.periodTo : ''
        )
        .replace(
          filter.groupIds?.length > 0 ? "<groupIds>" : "&groupIds=<groupIds>",
          filter.groupIds?.length > 0 ? filter.groupIds?.toString() : ''
        )
    );
  }
  // static getMetricsByFilter_CollectData(stdId, period, filter) {
  //   console.log(filter,'filter')
  //     return HttpUtil.get(
  //       API_ROUTES.STANDARDS.GET_METRICS_BY_FILTER_CLCT
  //       .replace("<standardId>", stdId)
  //       .replace("<period>", period)
  //       .replace("<categoryType>", filter.scope)
  //       .replace(
  //         filter.emissionId?.length > 0 ? "<emissionId>" : "&emissionId=<emissionId>", 
  //         filter.emissionId?.length > 0 ? filter.emissionId?.toString() : ''
  //       )
  //       .replace(
  //         filter.metricIds?.length > 0 ? "<metricIds>" : "&metricIds=<metricIds>", 
  //         filter.metricIds?.length > 0 ? filter.metricIds?.toString() : ''
  //       )
  //       .replace(
  //         filter.businessUnitIds?.length > 0 ? "<businessUnitIds>" : "&businessUnitIds=<businessUnitIds>", 
  //         filter.businessUnitIds?.length > 0 ? filter.businessUnitIds?.toString() : ''
  //       )
  //       .replace(
  //         filter.periodFrom && filter.periodTo ? "<periodFrom>": "&periodFrom=<periodFrom>", 
  //         filter.periodFrom && filter.periodTo ? filter.periodFrom : ''
  //       )
  //       .replace(
  //         filter.periodFrom && filter.periodTo ? "<periodTo>": "&periodTo=<periodTo>", 
  //         filter.periodFrom && filter.periodTo ? filter.periodTo : ''
  //       )

  //     );
  //   }
  static getMetricsByFilter_CollectData(stdId, period, filter) {
    console.log(filter, 'filter');

    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_METRICS_BY_FILTER_CLCT
        .replace("<standardId>", stdId)
        .replace("<period>", period)
        .replace("<scope>", filter.scope || '')
        .replace(
          filter.emission ? "<emissionId>" : "&emissionId=<emissionId>",
          filter.emission || ''
        )
        .replace(
          filter.metricIds?.length > 0 ? "<metricIds>" : "&metricIds=<metricIds>",
          filter.metricIds?.toString() || ''
        )
        .replace(
          filter.businessUnitIds?.length > 0 ? "<businessUnitIds>" : "&businessUnitIds=<businessUnitIds>",
          filter.businessUnitIds?.toString() || ''
        )
        .replace(
          filter.periodFrom && filter.periodTo ? "<periodFrom>" : "&periodFrom=<periodFrom>",
          filter.periodFrom || ''
        )
        .replace(
          filter.periodFrom && filter.periodTo ? "<periodTo>" : "&periodTo=<periodTo>",
          filter.periodTo || ''
        )
    );
  }


  static getMetricsForTopics(stdId, topicIds, cat = 0) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_METRICS_FOR_TOPICS
        .replace("<standardId>", stdId)
        .replace("<topicIds>", topicIds.toString())
        .replace("<cat>", cat)
    );
  }

  static getTopicsByStandard(stdId, forSuperAdmin = false, cat = 0, catType = -1, periodic = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(
        API_ROUTES.SUPER_ADMIN_STD.GET_ALL_BY_STANDARD
          .replace("<standardId>", stdId)
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.STANDARDS.GET_ALL_BY_STANDARD
          .replace("<standardId>", stdId)
          .replace("<cat>", cat)
          .replace(catType >= 0 ? "<catType>" : "&catType=<catType>", catType >= 0 ? catType : '')
          .replace(periodic ? "<periodic>" : "&periodic=<periodic>", periodic ? 'true' : '')
      );
    }
  }

  static getAggregatedMetricValuesWithDataPoints(stdId, period, metricCodes, qMetricCodes = null, gdQuesCodes = null) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_AGGREGATED_METRIC_DPS
        .replace("<standardId>", stdId)
        .replace("<period>", period)
        .replace("<metricCodes>", metricCodes)
        .replace(qMetricCodes ? "<qMetricCodes>" : "&qMetricCodes=<qMetricCodes>", qMetricCodes ?? '')
        .replace(gdQuesCodes ? "<gdQuesCodes>" : "&gdQuesCodes=<gdQuesCodes>", gdQuesCodes ?? '')
    );
  }

  static saveFromESGDataset(standardId, payload, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.post(
        API_ROUTES.SUPER_ADMIN_STD.SAVE_TEMPLATE_FROM_ESG_DATASET
          .replace('<standardId>', standardId), payload
      );
    } else {
      return HttpUtil.post(API_ROUTES.STANDARDS.SAVE_TEMPLATE_FROM_ESG_DATASET.replace('<standardId>', standardId), payload);
    }
  }

  static getQuantitativeMetricDataPointsData(stdId, period, metricCodes, topicId = 0, periodStart = '', periodEnd = '', buIds = []) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_QUAN_METRIC_DPS
        .replace("<standardId>", stdId)
        .replace("<period>", period)
        .replace("<metricCodes>", metricCodes)
        .replace("<topicId>", topicId)
        .replace(periodStart && periodEnd ? "<periodStart>" : "&periodStart=<periodStart>", periodStart)
        .replace(periodStart && periodEnd ? "<periodEnd>" : "&periodEnd=<periodEnd>", periodEnd)
        .replace(
          buIds?.length > 0 ? "<buIds>" : "&buIds=<buIds>",
          buIds?.length > 0 ? buIds?.toString() : ''
        )
    );
  }

  static getQualitativeMetricQuestionAnswers(stdId, period, metricCodes, topicId = 0, periodStart = '', periodEnd = '', buIds = []) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_QUAL_METRIC_QUES_ANS
        .replace("<standardId>", stdId)
        .replace("<period>", period)
        .replace("<metricCodes>", metricCodes)
        .replace("<topicId>", topicId)
        .replace(periodStart && periodEnd ? "<periodStart>" : "&periodStart=<periodStart>", periodStart)
        .replace(periodStart && periodEnd ? "<periodEnd>" : "&periodEnd=<periodEnd>", periodEnd)
        .replace(
          buIds?.length > 0 ? "<buIds>" : "&buIds=<buIds>",
          buIds?.length > 0 ? buIds?.toString() : ''
        )
    );
  }

  static getMetricComparison(filter) {
    return HttpUtil.post(
      API_ROUTES.STANDARDS.GET_METRIC_COMPARE, filter);
  }

  static getQualitativeDataByFilter(stdId, period, filter) {
    return HttpUtil.post(
      API_ROUTES.STANDARDS.GET_QUALITATIVE_DATA
        .replace("<standardId>", stdId)
        .replace("<period>", period)
        .replace("<categoryType>", CompareCategoryType[filter.categoryType])
        .replace(
          filter.topicIds?.length > 0 ? "<topicIds>" : "&topicIds=<topicIds>",
          filter.topicIds?.length > 0 ? filter.topicIds?.toString() : ''
        )
        .replace(
          filter.metricIds?.length > 0 ? "<metricIds>" : "&metricIds=<metricIds>",
          filter.metricIds?.length > 0 ? filter.metricIds?.toString() : ''
        )
        .replace(
          filter.businessUnitIds?.length > 0 ? "<businessUnitIds>" : "&branchIds=<businessUnitIds>",
          filter.businessUnitIds?.length > 0 ? filter.businessUnitIds?.toString() : ''
        )
        .replace(
          filter.periodFrom && filter.periodTo ? "<periodFrom>" : "&periodFrom=<periodFrom>",
          filter.periodFrom && filter.periodTo ? filter.periodFrom : ''
        )
        .replace(
          filter.periodFrom && filter.periodTo ? "<periodTo>" : "&periodTo=<periodTo>",
          filter.periodFrom && filter.periodTo ? filter.periodTo : ''
        )
    );
  }

  static getQuestionAnswers(metricId, period, filter) {
    return HttpUtil.post(
      API_ROUTES.STANDARDS.GET_QNANS_DATA
        .replace("<metricId>", metricId)
        .replace("<period>", period)
        .replace(
          filter.businessUnitIds?.length > 0 ? "<businessUnitIds>" : "&branchIds=<businessUnitIds>",
          filter.businessUnitIds?.length > 0 ? filter.businessUnitIds?.toString() : ''
        )
    );
  }

  static postQualMetricAnswers(period, payload) {
    return HttpUtil.post(API_ROUTES.STANDARDS.POST_QUAL_METRIC_ANS.replace("<period>", period), payload);
  }

  static getDocumentsAttached(id) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_DOCUMENTS_ATTACHED.replace("<externalId>", id));
  }

  static uploadAttachments(data) {
    return HttpUtil.post(
      API_ROUTES.STANDARDS.UPLOAD_ATTACHMENTS, data);
  }

  static saveBranchCommentsAttachments(date, body) {
    return HttpUtil.post(
      API_ROUTES.STANDARDS.SAVE_COMMENTS_ATTACHMENTS.replace("<date>", date),
      body
    );
  }
  static getDocumentsAttachedAlt(id) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_DOCUMENTS_ATTACHED_ALT.replace("<id>", id));
  }

  static exportCompareData(filter) {
    return HttpUtil.postExcelData(
      API_ROUTES.STANDARDS.EXPORT_COMPARE_DATA, filter);
  }

  static getESGTopics(standardId, lang) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_ESG_TOPICS
        .replace("<standardId>", standardId)
        .replace("<lang>", lang)
    );
  }
  static saveUomTableValue(payload) {
    return HttpUtil.post(API_ROUTES.STANDARDS.SAVE_UOM_TABLE_ROW, payload);
  }
  static updateUomTableValue(id, payload) {
    return HttpUtil.put(API_ROUTES.STANDARDS.UPDATE_UOM_TABLE_ROW.replace("<id>", id), payload);
  }
  static getScopeCategory(stdId) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_SCOPE_CAT
        .replace("<standardId>", stdId))


  }
  //   static getMetricAndDataPoint(stdId, businessUnitIds, periodFrom, periodTo, scope, category) {
  //   let url = API_ROUTES.STANDARDS.GET_METRIC_DATAPOINT.replace("<standardId>", stdId);

  //   const params = [];

  //   if (businessUnitIds?.length > 0) {
  //     params.push(`businessUnitIds=${businessUnitIds.toString()}`);
  //   }
  //   if (periodFrom) {
  //     params.push(`periodFrom=${periodFrom}`);
  //   }
  //   if (periodTo) {
  //     params.push(`periodTo=${periodTo}`);
  //   }
  //   if (scope) {
  //     params.push(`scope=${scope}`);
  //   }
  //   if (category) {
  //     params.push(`category=${category}`);
  //   }

  //   if (params.length > 0) {
  //     url += `?${params.join("&")}`;
  //   }

  //   return HttpUtil.get(url);
  // }
  static getMetricAndDataPoint(stdId, businessUnitIds, periodFrom, periodTo, scope, category) {
    let url = API_ROUTES.STANDARDS.GET_METRIC_DATAPOINT.replace("<standardId>", stdId);

    // Build query params
    const params = new URLSearchParams();

    // Hardcoded for now or passed as args
    if (businessUnitIds?.length > 0) {
      params.append("businessUnitIds", businessUnitIds);
    }
    if (periodFrom) {
      params.append("periodFrom", periodFrom);
    }
    if (periodTo) {
      params.append("periodTo", periodTo);
    }
    if (scope) {
      params.append("scope", scope);
    }
    if (category) {
      params.append("category", category);
    }

    // Attach query string
    url += `?${params.toString()}`;

    return HttpUtil.get(url);
  }
  static getMetricDataPointList(metricId, standardId, periodFrom) {
    return HttpUtil.get(API_ROUTES.STANDARDS.GET_METRIC_DATAPOINT_LIST
      .replace("<metricId>", metricId)
      .replace("<standardId>", standardId)
      .replace("<periodFrom>", periodFrom ?? ''));
  }

  static getAPageOfDps(
    stdId,
    pageNumber = 0,
    pageSize = 10,
    dsLinked = false,
    fetchAll = false,
    key = "",
    sort = "",
  ) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_DP_PAGE
        .replace("<stdId>", stdId)
        .replace("<pageSize>", pageSize)
        .replace("<pageNumber>", pageNumber)
        .replace("<dsLinked>", dsLinked)
        .replace("<fetchAll>", fetchAll)
    );
  }

  static getAllMetricsAndDatapoints(standardId, sCat='', topicIds = []) {
    return HttpUtil.get(
      API_ROUTES.STANDARDS.GET_ALL_METRICS_DATAPOINTS
        .replace("<standardId>", standardId)
        .replace(sCat ? '<sCat>' : "&sCat=<sCat>", sCat ?? '')
        .replace("<topicIds>", topicIds.toString())
    );
  }

  static getTopicsMetricsDps(standardId, category = null, topicIds = [], metricIds = [], dpIds = []) {
    let baseUrl = API_ROUTES.STANDARDS.GET_TOPICS_METRICS_DPS.replace("<standardId>", standardId);
    
    const params = [];
    if (category !== null && category !== undefined) {
      params.push(`category=${category}`);
    }
    if (topicIds && topicIds.length > 0) {
      params.push(`topicIds=${topicIds.join(",")}`);
    }
    if (metricIds && metricIds.length > 0) {
      params.push(`metricIds=${metricIds.join(",")}`);
    }
    if (dpIds && dpIds.length > 0) {
      params.push(`dpIds=${dpIds.join(",")}`);
    }
    
    const url = baseUrl.replace("?category=<cat>&topicIds=<topicIds>&metricIds=<metricIds>&dpIds=<dpIds>", 
      params.length > 0 ? `?${params.join("&")}` : "");
    
    return HttpUtil.get(url);
  }

  static finalizeConfiguration(standardId, payload, forSuperAdmin = false) {
    const url = API_ROUTES.STANDARDS.FINALIZE_CONFIG
      .replace("<standardId>", standardId);
    return HttpUtil.post(url, payload);
  }

  static getFormCreationStatus(companyId, standardId) {
    const url = API_ROUTES.TRANSACTIONS.GET_FORM_CREATION_STATUS
      .replace("<companyId>", companyId)
      .replace("<standardId>", standardId);
    
    return HttpUtil.get(url);
  }

  static reorderTopic(stdId, topicId, payload) {
    return HttpUtil.put(
      API_ROUTES.STANDARDS.REORDER_TOPIC
        .replace("<standardId>", stdId)
        .replace("<topicId>", topicId),
      payload
    );
  }

  static reorderMetric(metricId, payload) {
    return HttpUtil.put(
      API_ROUTES.STANDARDS.REORDER_METRIC.replace("<metricId>", metricId),
      payload
    );
  }

  static reorderDataPoint(dataPointId, payload) {
    return HttpUtil.put(
      API_ROUTES.STANDARDS.REORDER_DATAPOINT.replace("<dataPointId>", dataPointId),
      payload
    );
  }

  static exportStandardConfigPartial(stdId, exportType, ids, forSuperAdmin = false) {
    const url = forSuperAdmin
      ? API_ROUTES.SUPER_ADMIN_STD.EXPORT_STANDARD_CONFIG_PARTIAL.replace("<standardId>", stdId)
      : API_ROUTES.STANDARDS.EXPORT_STANDARD_CONFIG_PARTIAL.replace("<standardId>", stdId);
    const idsParam = Array.isArray(ids) ? ids.join(",") : ids;
    return HttpUtil.getExcelData(url, {
      params: {
        exportType,
        ids: idsParam,
      },
    });
  }

  static exportTopics(stdId, payload, forSuperAdmin = false) {
    const ids = payload?.topicIds || [];
    return StandardService.exportStandardConfigPartial(stdId, "TOPICS", ids, forSuperAdmin);
  }

  static importTopics(stdId, formData, forSuperAdmin = false) {
    const url = forSuperAdmin
      ? API_ROUTES.SUPER_ADMIN_STD.IMPORT_TOPICS.replace("<standardId>", stdId)
      : API_ROUTES.STANDARDS.IMPORT_TOPICS.replace("<standardId>", stdId);
    return HttpUtil.post(url, formData);
  }

  static exportMetrics(stdId, topicId, payload, forSuperAdmin = false) {
    const ids = payload?.metricIds || [];
    return StandardService.exportStandardConfigPartial(stdId, "METRICS", ids, forSuperAdmin);
  }

  static importMetrics(stdId, topicId, formData, forSuperAdmin = false) {
    const url = forSuperAdmin
      ? API_ROUTES.SUPER_ADMIN_STD.IMPORT_METRICS
        .replace("<standardId>", stdId)
        .replace("<topicId>", topicId)
      : API_ROUTES.STANDARDS.IMPORT_METRICS
        .replace("<standardId>", stdId)
        .replace("<topicId>", topicId);
    return HttpUtil.post(url, formData);
  }

  static exportDataPoints(stdId, payload, forSuperAdmin = false) {
    const ids = payload?.dataPointIds || [];
    return StandardService.exportStandardConfigPartial(stdId, "DATA_POINTS", ids, forSuperAdmin);
  }

  static importDataPoints(stdId, metricId, formData, forSuperAdmin = false) {
    const url = forSuperAdmin
      ? API_ROUTES.SUPER_ADMIN_STD.IMPORT_DATAPOINTS
        .replace("<standardId>", stdId)
        .replace("<metricId>", metricId)
      : API_ROUTES.STANDARDS.IMPORT_DATAPOINTS
        .replace("<standardId>", stdId)
        .replace("<metricId>", metricId);
    return HttpUtil.post(url, formData);
  }

  static moveMetricsToTopic(topicId, metricIds, forSuperAdmin = false) {
    const url = forSuperAdmin
      ? API_ROUTES.SUPER_ADMIN_STD.MOVE_METRICS_TO_TOPIC.replace("<topicId>", topicId)
      : API_ROUTES.STANDARDS.MOVE_METRICS_TO_TOPIC.replace("<topicId>", topicId);
    const metricIdsParam = Array.isArray(metricIds) ? metricIds.join(",") : metricIds;
    return HttpUtil.put(`${url}?metricIds=${encodeURIComponent(metricIdsParam)}`);
  }

  static moveDataPointsToMetric(metricId, dataPointIds, forSuperAdmin = false) {
    const url = forSuperAdmin
      ? API_ROUTES.SUPER_ADMIN_STD.MOVE_DATAPOINTS_TO_METRIC.replace("<metricId>", metricId)
      : API_ROUTES.STANDARDS.MOVE_DATAPOINTS_TO_METRIC.replace("<metricId>", metricId);
    const dpIdsParam = Array.isArray(dataPointIds) ? dataPointIds.join(",") : dataPointIds;
    return HttpUtil.put(`${url}?dpIds=${encodeURIComponent(dpIdsParam)}`);
  }

  static reorderQuestion(questionId, payload) {
    return HttpUtil.put(
      API_ROUTES.STANDARDS.REORDER_QUESTION.replace("<questionId>", questionId),
      payload
    );
  }
}
